export default __webpack_public_path__ + "static/media/mail.caf90129.svg";